import { NavLink } from "react-router-dom";
import { useClientPortalBase, useClientPortalPaths } from "../../hooks/useClientPortalBase";
import { CASAMAPA_ADMIN_PORTAL_BASE } from "../../constants/clientAdminPortalRoutes";

const BASE_ITEMS = [
  { segment: "", label: "General", end: true },
  { segment: "audit", label: "Audit" },
];

const CASAMAPA_ITEMS = [{ segment: "data-sources", label: "Data Sources" }];

export default function ClientSettingsSubnav({ clientViewId }) {
  const portalBase = useClientPortalBase();
  const paths = useClientPortalPaths();
  const settingsBase = paths.viewSection(clientViewId, "settings");
  const isCasaMapa = portalBase === CASAMAPA_ADMIN_PORTAL_BASE;

  const items = isCasaMapa
    ? [BASE_ITEMS[0], ...CASAMAPA_ITEMS, BASE_ITEMS[1]]
    : BASE_ITEMS;

  return (
    <nav className="cp-settings-subnav" aria-label="Settings sections">
      {items.map((item) => (
        <NavLink
          key={item.segment || "general"}
          to={item.segment ? `${settingsBase}/${item.segment}` : settingsBase}
          end={item.end}
          className={({ isActive }) =>
            `cp-settings-subnav__tab${isActive ? " cp-settings-subnav__tab--active" : ""}`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}
